<template>
    <v-app id="c4k">
        <router-view></router-view>
        <NotificationSnackbar/>
    </v-app>
</template>
<script>

import { mapGetters } from 'vuex';
import DarkMode from '../../global/mixins/DarkMode';
import NotificationSnackbar from './components/Global/Notifications/NotificationSnackbar';

export default {
  name: 'App',
  data() {
    return {
      drawer: false,
    };
  },
  // mixins: [DarkMode],
  components: {
    NotificationSnackbar,
  },

  methods: {},

  computed: {
    ...mapGetters(['globalLoading', 'darkMode', 'verified']),
    loading() {
      return this.globalLoading;
    },

  },
  mounted() {
  },
};
</script>

<style lang="scss">

    @import '../../global/assets/scss/main';

    .v-toolbar__extension {
        padding: 0 !important;
        display: block !important;
    }

    html,
    body {
        height: 100%;
        margin: 0;
    }

    html {
        content: ''; /* (ab)using the content property */
    }

    /* Light mode */
    @media (prefers-color-scheme: light) {
        html {
            content: 'light'; /* (ab)using the content property */
        }
    }

    /* Dark mode */
    @media (prefers-color-scheme: dark) {
        html {
            content: 'dark'; /* (ab)using the content property */
        }
    }

</style>
